/**
 * Dashboard product page path pattern: /dashboard/:uuid/products/...
 * Used to decide whether to open the product overlay or open the link in a new tab.
 */
const DASHBOARD_PRODUCT_PAGE_PATH_REGEX = /^\/dashboard\/[^/]+\/products\//;

/**
 * Returns true only when the URL pathname matches the dashboard product page pattern.
 * Relative paths (e.g. /dashboard/abc/products/llc-formation) and absolute URLs
 * (e.g. https://app.zenbusiness.com/dashboard/abc/products/llc-formation) are supported.
 *
 * @param {string|null|undefined} ctaUrl - URL to check (resolved from product registry urlTemplate)
 * @returns {boolean} True if ctaUrl is a dashboard product page path; false otherwise
 */
function isDashboardProductPageUrl(ctaUrl) {
  if (ctaUrl == null || typeof ctaUrl !== 'string') {
    return false;
  }

  const trimmed = ctaUrl.trim();
  if (trimmed === '') {
    return false;
  }

  let pathname;
  if (trimmed.startsWith('/')) {
    pathname = trimmed;
  } else {
    try {
      pathname = new URL(ctaUrl).pathname;
    } catch {
      return false;
    }
  }

  return DASHBOARD_PRODUCT_PAGE_PATH_REGEX.test(pathname);
}

export default isDashboardProductPageUrl;
